const et = {
  brand: "E2 Care",
  tagline: "Rahulik, ühendatud hooldus.",
  nav_dashboard: "Töölaud",
  nav_residents: "Patsiendid",
  nav_patients: "Patsiendid",
  nav_rooms: "Ruumid",
  nav_devices: "Seadmed",
  nav_events: "Sündmused",
  nav_alerts: "Hoiatused",
  nav_users: "Meeskond",
  nav_settings: "Seaded",
  nav_admin: "Haldus",
  nav_signout: "Logi välja",
  topbar_search_placeholder: "Otsi patsiente, ruume, seadmeid…",
  admin_super_only: "Ainult superadministraatorid saavad organisatsioone hallata.",
  admin_admin_only: "Sellele lehele pääsevad ainult administraatorid.",
  admin_tab_orgs: "Organisatsioonid",
  admin_tab_users: "Kasutajad",
  admin_tab_patients: "Patsiendid",
  admin_tab_rooms: "Ruumid",
  admin_tab_buildings: "Hooned",
  admin_tab_devices: "Seadmed",
  admin_tab_alerts: "Häired",
  admin_tab_qa: "Testivahendid",
  admin_delete: "Kustuta",
  admin_no_orgs_yet: "Organisatsioone pole veel.",
  admin_field_name: "Nimi",
  admin_field_email: "E-post",
  admin_field_phone: "Telefon",
  admin_field_password: "Parool",
  admin_field_role: "Roll",
  admin_field_type: "Tüüp",
  admin_field_timezone: "Ajavöönd",
  admin_field_address: "Aadress",
  admin_field_status: "Olek",
  admin_field_organization: "Organisatsioon",
  admin_password_keep: "Jäta tühjaks, et säilitada",
  admin_field_birth_date: "Sünnikuupäev",
  admin_field_room: "Ruum",
  admin_field_room_none: "Määramata",
  admin_field_photo: "Foto URL",
  admin_field_photo_hint: "Kleebi avalik URL — täielik üleslaadimine v2-s.",
  admin_field_notes: "Hooldaja märkmed",
  admin_field_emergency_contact: "Peamine hädaolukorra kontakt",
  admin_field_ec_name: "Nimi",
  admin_field_ec_phone: "Telefon",
  admin_field_ec_relationship: "Suhe",
  admin_field_mac: "MAC-aadress",
  admin_field_firmware: "Püsivara",
  admin_field_assignment: "Määratud",
  admin_field_assigned_room: "Määratud ruum",
  admin_field_assigned_patient: "Määratud patsient",
  admin_field_assigned_hint: "Valikuline. Andurid → ruum; käevõrud → patsient.",
  admin_field_sensor_target: "Paigaldatud",
  admin_field_sensor_target_hint: "Ütleb süsteemile, kas see andur jälgib ust või akent.",
  sensor_target_door: "Uks",
  sensor_target_window: "Aken",
  sensor_target_unset: "Seadistamata",
  admin_field_sensor_label: "Anduri silt",
  admin_field_sensor_label_hint: "Sõbralik nimi, mida kuvatakse häiretes ja sündmustes — nt „Esiuks“, „Vannitoa aken“.",
  admin_field_building: "Hoone",
  admin_field_building_required: "Tuba peab kuuluma hoonesse.",
  room_openings: "Avad",
  room_no_openings: "Sellesse tuppa pole veel ukse- ega aknaandureid paigaldatud.",
  room_openings_summary: "{doors} {doorsLabel} · {windows} {windowsLabel}",
  opening_last_event: "Viimane muutus",
  admin_field_description: "Kirjeldus",
  admin_field_severity: "Raskusaste",
  admin_field_patient: "Patsient",
  admin_field_device: "Seade",
  admin_field_message: "Sõnum",
  admin_orgs_title: "Organisatsioonid",
  admin_orgs_sub: "Loo, muuda ja arhiveeri E2 Care rentnikke.",
  admin_orgs_count: "organisatsioonid",
  admin_org_new: "Uus organisatsioon",
  admin_org_new_title: "Uus organisatsioon",
  admin_org_edit_title: "Muuda organisatsiooni",
  admin_org_created: "Organisatsioon loodud.",
  admin_org_updated: "Organisatsioon uuendatud.",
  admin_org_deleted: "Organisatsioon arhiveeritud.",
  admin_org_delete_title: "Arhiveerida organisatsioon?",
  admin_org_delete_confirm: "«{name}» peidetakse nimekirjadest.",
  admin_users_title: "Kasutajad",
  admin_users_sub_super: "Halda kõiki kasutajakontosid kõigis rentnikes.",
  admin_users_sub_org: "Halda {org} kasutajakontosid.",
  admin_user_new: "Uus kasutaja",
  admin_user_new_title: "Uus kasutaja",
  admin_user_edit_title: "Muuda kasutajat",
  admin_user_created: "Kasutaja loodud.",
  admin_user_updated: "Kasutaja uuendatud.",
  admin_user_deleted: "Kasutaja arhiveeritud.",
  admin_user_delete_title: "Arhiveerida kasutaja?",
  admin_user_delete_confirm: "«{name}» kaotab juurdepääsu.",
  admin_user_memberships: "Organisatsiooni liikmesused",
  admin_patients_title: "Patsiendid",
  admin_patients_sub_super: "Halda kõiki patsiente kõigis rentnikes.",
  admin_patients_sub_org: "Halda patsiente {org}-s.",
  admin_patient_new: "Uus patsient",
  admin_patient_new_title: "Uus patsient",
  admin_patient_edit_title: "Muuda patsienti",
  admin_patient_created: "Patsient loodud.",
  admin_patient_updated: "Patsient uuendatud.",
  admin_patient_deleted: "Patsient arhiveeritud.",
  admin_patient_delete_title: "Arhiveerida patsient?",
  admin_patient_delete_confirm: "«{name}» peidetakse nimekirjadest.",
  admin_rooms_title: "Ruumid",
  admin_rooms_sub_super: "Seadista ruumid kõigis rentnikes.",
  admin_rooms_sub_org: "Seadista ruumid {org}-s.",
  admin_room_new: "Uus ruum",
  admin_room_new_title: "Uus ruum",
  admin_room_edit_title: "Muuda ruumi",
  admin_room_created: "Ruum loodud.",
  admin_room_updated: "Ruum uuendatud.",
  admin_room_deleted: "Ruum arhiveeritud.",
  admin_room_delete_title: "Arhiveerida ruum?",
  admin_room_delete_confirm: "«{name}» peidetakse.",
  admin_devices_title: "Seadmed",
  admin_devices_sub_super: "Varusta Moko seadmeid kõigis rentnikes.",
  admin_devices_sub_org: "Varusta Moko seadmeid {org}-s.",
  admin_device_new: "Uus seade",
  admin_device_new_title: "Uus seade",
  admin_device_edit_title: "Muuda seadet",
  admin_device_created: "Seade loodud.",
  admin_device_updated: "Seade uuendatud.",
  admin_device_deleted: "Seade arhiveeritud.",
  admin_device_delete_title: "Arhiveerida seade?",
  admin_device_delete_confirm: "Seade {mac} peidetakse.",
  admin_buildings_title: "Hooned",
  admin_buildings_sub_super: "Grupeeri ruumid hoonete / tiibade kaupa kõigis rentnikes.",
  admin_buildings_sub_org: "Grupeeri ruumid hoonete / tiibade kaupa {org}-s.",
  admin_building_new: "Uus hoone",
  admin_building_new_title: "Uus hoone",
  admin_building_edit_title: "Muuda hoonet",
  admin_building_created: "Hoone loodud.",
  admin_building_updated: "Hoone uuendatud.",
  admin_building_deleted: "Hoone arhiveeritud.",
  admin_building_delete_title: "Arhiveerida hoone?",
  admin_building_delete_confirm: "«{name}» peidetakse.",
  admin_qa_title: "Testivahendid",
  admin_qa_sub: "Süsti sündmusi / hoiatusi, et testida ilma reaalse Moko riistvarata.",
  admin_qa_event_title: "Süsti testsündmus",
  admin_qa_event_sub: "Simuleerib Moko webhooki.",
  admin_qa_alert_title: "Süsti testhoiatus",
  admin_qa_alert_sub: "Jätab sündmuste kihi vahele ja kirjutab hoiatuse otse.",
  admin_qa_inject_event: "Süsti sündmus",
  admin_qa_inject_alert: "Süsti hoiatus",
  admin_qa_event_done: "Sündmus süstitud.",
  admin_qa_alert_done: "Hoiatus süstitud.",
  admin_qa_disclaimer: "Need lõpp-punktid tuleb tootmises keelata.",
  admin_alerts_title: "Häirete poliitika",
  admin_alerts_sub: "Kogu {org} häirereeglid. Rakenduvad selle rentniku igale patsiendile.",
  admin_alerts_quiet_title: "Vaiksed tunnid",
  admin_alerts_quiet_desc: "Määrake, millal see organisatsioon on „öörežiimis“. Kasulik mittekriitiliste häirete vaiksemaks suunamiseks.",
  admin_alerts_quiet_hint: "Kellaajad tõlgendatakse organisatsiooni kohalikus ajavööndis. Vahemik võib ületada südaööd (nt 22:00 → 06:00).",
  admin_alerts_night_start: "Öö algab",
  admin_alerts_night_end: "Öö lõpeb",
  admin_alerts_load_failed: "Laadi häirete poliitika",
  admin_alerts_save_failed: "Salvesta häirete poliitika",
  admin_alerts_saved: "Häirete poliitika salvestatud.",
  admin_alerts_clear_title: "Tühjenda aktiivsed häired",
  admin_alerts_clear_desc: "Kinnita kõik selle organisatsiooni avatud häired ühe klõpsuga.",
  admin_alerts_clear_hint: "Kasulik pärast plaanitud õppust või valesti seadistatud andurit, mis tekitas valehäirete laine. Kinnitatud häired jäävad ajalukku.",
  admin_alerts_ack_all_button: "Kinnita kõik",
  admin_alerts_ack_all_title: "Kinnita kõik aktiivsed häired?",
  admin_alerts_ack_all_confirm: "See märgib kinnitatuks iga avatud häire organisatsioonis {org}. Seda toimingut ei saa tagasi võtta.",
  admin_alerts_ack_all_done: "{count} häire(t) kinnitatud.",
  admin_alerts_ack_all_done_generic: "Kõik aktiivsed häired kinnitatud.",
  admin_alerts_ack_all_failed: "Kinnita kõik häired",
  org_type_nursing_home: "Hooldekodu",
  org_type_assisted_living: "Toetatud elamine",
  org_type_hospital: "Haigla",
  org_type_home_care: "Koduhooldus",
  role_admin: "Administraator",
  role_caregiver: "Hooldaja",
  role_family: "Perekond",
  status_active: "aktiivne",
  status_inactive: "mitteaktiivne",
  confirm: "Kinnita",
  sign_in: "Logi sisse",
  signed_in: "Sisse logitud",
  sign_up: "Registreeru",
  email: "E-post",
  password: "Parool",
  full_name: "Täisnimi",
  create_account: "Loo konto",
  no_account: "Kontot veel pole?",
  have_account: "Kas teil on juba konto?",
  login_welcome: "Tere tulemast tagasi",
  login_sub: "Logi sisse, et jätkata elanike jälgimist.",
  register_welcome: "Liitu E2 Care-ga",
  register_sub: "Loo oma tööruum vähem kui minutiga.",
  total_residents: "Patsiendid",
  active_devices: "Aktiivsed seadmed",
  open_alerts: "Avatud hoiatused",
  offline_gateways: "Võrguühenduseta seadmed",
  falls_7d: "Kukkumised (7p)",
  sos_7d: "SOS (7p)",
  low_battery: "Madal aku",
  critical_residents: "Kriitilised",
  status_ok: "Kõik korras",
  status_warning: "Tähelepanu",
  status_critical: "Kriitiline",
  status_online: "Võrgus",
  status_offline: "Võrguühenduseta",
  search: "Otsi",
  filter: "Filtreeri",
  all: "Kõik",
  refresh: "Värskenda",
  loading: "Laadimine…",
  no_results: "Siin pole veel midagi.",
  view_profile: "Vaata profiili",
  showing_n_of_m: "Kuvatakse {n} / {m}",
  load_more: "Lae rohkem",
  auto_refresh: "Otseülekanne · automaatne värskendamine",
  auto_refresh_paused: "Peatatud (lae rohkem aktiivne)",
  updated_just_now: "Värskendatud just",
  updated_n_sec_ago: "Värskendatud {n}s tagasi",
  updated_n_min_ago: "Värskendatud {n}m tagasi",
  acknowledge: "Kinnita",
  acknowledged: "Kinnitatud",
  ack_all: "Kinnita kõik",
  ack_all_confirm: "Kinnita kõik {count} aktiivset häiret?",
  ack_all_running: "Kinnitamine…",
  ack_all_done: "{count} häire(t) kinnitatud.",
  ack_all_partial: "{ok} kinnitatud · {fail} ebaõnnestus.",
  last_seen: "Viimati nähtud",
  battery: "Aku",
  signal: "Signaal",
  firmware: "Püsivara",
  room: "Krt / Tuba",
  age: "Vanus",
  emergency_contact: "Hädaolukorra kontakt",
  notes: "Märkmed",
  assigned_devices: "Määratud seadmed",
  recent_events: "Hiljutised sündmused",
  timeline_24h: "Viimased 24 tundi",
  delivery_status: "Tarne olek",
  acknowledged_by: "Kinnitanud",
  dashboard_title: "Ülevaade",
  dashboard_sub: "Kiire ülevaade kõigest, mis toimub kodudes, mida hooldate.",
  residents_title: "Patsiendid",
  residents_sub: "Inimesed, keda praegu jälgite.",
  devices_title: "Seadmed",
  devices_sub: "Andurid ja käevõrud.",
  devices_sub_admin: "Lüüsid, andurid ja käevõrud.",
  events_title: "Otsesündmused",
  events_sub: "Kronoloogiline voog igast ühendatud seadmest.",
  alerts_title: "Hoiatused",
  alerts_sub: "Perele ja hooldajatele edastatud teated.",
  settings_title: "Seaded",
  settings_sub: "Teie eelistused ja teavitusreeglid.",
  users_title: "Meeskond",
  users_sub: "Juurdepääsuga hooldajad, perekond ja administraatorid.",
  falls_chart_title: "Kukkumised & SOS — viimased 7 päeva",
  recent_alerts_title: "Hiljutised kriitilised hoiatused",
  no_alerts: "Avatud hoiatusi pole. Kõik on turvalised.",
  event_fall: "Tuvastatud kukkumine",
  event_sos: "SOS-nuppu vajutatud",
  event_door_open: "Uks avatud",
  event_door_close: "Uks suletud",
  event_inactivity: "Pikaajaline tegevusetus",
  event_low_battery: "Madal aku",
  event_offline: "Seade võrguühenduseta",
  event_online: "Seade taas võrgus",
  event_heartbeat: "Südamelöök",
  event_button_press: "Nuppu vajutatud",
  device_gateway: "Bluetooth-lüüs",
  device_door_sensor: "Ukseandur",
  device_bracelet: "Käevõru",
  device_unknown: "Tundmatu seade",
  language: "Keel",
  notifications: "Teavitused",
  quiet_hours: "Vaiksed tunnid",
  escalation: "Eskaleerimise poliitika",
  just_now: "just nüüd",
  rel_prefix: "",
  min_ago: "min tagasi",
  h_ago: "t tagasi",
  d_ago: "p tagasi",
  demo_hint: "Demokonto: admin@e2care.lv / Care2024!",
  open_menu: "Ava menüü",
  close_menu: "Sulge menüü",
  care_team: "Hooldusmeeskond",
  family_members: "Perekond",
  no_caregivers: "Hooldajaid pole veel määratud.",
  no_family: "Pereliikmeid pole veel lisatud.",
  add_caregiver: "Lisa hooldaja",
  add_family: "Lisa pereliige",
  select_user: "Vali kasutaja…",
  cancel: "Tühista",
  add: "Lisa",
  remove: "Eemalda",
  save: "Salvesta",
  relationship: "Suhe",
  relationship_son: "Poeg",
  relationship_daughter: "Tütar",
  relationship_spouse: "Abikaasa",
  relationship_other: "Muu",
  notify_via: "Teavita kanali kaudu",
  call_contact: "Helista",
  view_resident: "Ava profiil",
  address: "Aadress",
  admin_only_section: "Administraatori tööriistad",
  rooms_title: "Ruumid",
  rooms_sub: "Iga ruum, mida jälgite — patsiendid, seadmed ja praegune olek.",
  room_name: "Ruum",
  room_type: "Tüüp",
  room_type_private_room: "Privaattuba",
  room_type_shared_room: "Jagatud tuba",
  room_type_apartment: "Korter",
  room_type_corridor: "Koridor",
  room_type_common_area: "Üldkasutatav ala",
  room_floor: "Korrus",
  room_state: "Praegune olek",
  door: "Uks",
  window: "Aken",
  door_open_state: "Avatud",
  door_closed_state: "Suletud",
  door_unknown_state: "Tundmatu",
  room_no_devices: "Selles ruumis pole veel seadmeid.",
  room_no_patients: "Sellele ruumile pole veel patsiente määratud.",
  room_patients: "Patsiendid ruumis",
  room_devices: "Seadmed ruumis",
  room_activity: "Tegevuse ajatelg",
  rooms_filter_all_types: "Kõik tüübid",
  widget_active_alerts: "Aktiivsed hoiatused",
  widget_active_alerts_sub: "Kriitilised, lahendamata ja kinnitatud",
  widget_patients_status: "Patsientide olek",
  widget_devices_health: "Seadmete tervis",
  widget_room_activity: "Ruumide tegevus",
  widget_recent_events: "Otseste sündmuste voog",
  widget_connectivity: "Ühenduvus",
  metric_critical: "Kriitiline",
  metric_unresolved: "Lahendamata",
  metric_acknowledged_count: "Kinnitatud",
  metric_total: "Kokku",
  metric_active: "Aktiivsed",
  metric_online: "Võrgus",
  metric_offline: "Võrguühenduseta",
  metric_ota_pending: "OTA ootel",
  metric_battery_warn: "Madal aku",
  metric_doors_open: "Avatud uksed",
  metric_windows_open: "Avatud aknad",
  metric_signal_avg: "Keskm. signaal",
  metric_last_comm: "Viim. side",
  metric_packets: "Pakette / h",
  view_all: "Vaata kõiki",
  status_new: "Uus",
  status_acknowledged: "Kinnitatud",
  status_resolved: "Lahendatud",
  status_resolved_local: "Lahendatud (kohalik)",
  resolve: "Lahenda",
  add_note: "Lisa märkus",
  save_note: "Salvesta märkus",
  resolve_local_badge: "ainult see seade",
  resolve_local_hint: "Märgib häire lahendatuks ainult teie brauseris. Server ja teised meeskonnaliikmed näevad seda endiselt avatuna.",
  note_placeholder: "Lisa konteksti meeskonnale…",
  notes_count: "{n} märkust",
  device_detail: "Seadme detail",
  device_diagnostics: "Diagnostika",
  device_firmware_history: "Püsivara ajalugu",
  device_ota_config: "OTA konfiguratsioon",
  device_ota_status: "OTA olek",
  device_signal: "Signaali kvaliteet",
  device_mac: "MAC-aadress",
  device_serial: "Seerianumber",
  fall_sensitivity: "Kukkumistundlikkus",
  transmission_interval: "Edastusintervall",
  low_battery_threshold: "Madala aku lävi",
  ota_idle: "Jõude",
  ota_pending: "Ootel",
  ota_deploying: "Juurutamine",
  ota_failed: "Ebaõnnestus",
  events_filter_severity: "Raskusaste",
  events_filter_room: "Ruum",
  events_filter_patient: "Patsient",
  events_filter_device: "Seade",
  severity_info: "Info",
  severity_warning: "Hoiatus",
  severity_critical: "Kriitiline",
  telegram_title: "Telegrami hoiatused",
  telegram_desc: "Saa Telegrami hoiatusi teile määratud elanike kohta.",
  telegram_connect: "Ühenda Telegram",
  telegram_connected: "Telegram ühendatud",
  telegram_connected_as: "Telegramiga ühendatud kui {name}",
  telegram_connect_success: "Telegram edukalt ühendatud",
  telegram_connect_error: "Telegrami ühendamine ebaõnnestus. Proovige uuesti.",
  telegram_missing_bot: "Telegrami bot pole seadistatud. Määrake REACT_APP_TELEGRAM_BOT env-failis.",
  telegram_disconnect: "Ühenda lahti",
  telegram_disconnect_success: "Telegram lahti ühendatud.",
  telegram_disconnect_error: "Telegrami lahtiühendamine ebaõnnestus. Proovige uuesti.",
  telegram_already_linked: "See Telegrami konto on juba seotud teise e2-care kasutajaga.",
  telegram_switch_q: "Kasutada teist Telegrami kontot?",
  telegram_switch_intro: "Telegram mäletab kõigil veebisaitidel, milline konto on sisse logitud. Teise kasutamiseks:",
  telegram_switch_step1: "Avage Telegram Web ja logige praegusest kontost välja.",
  telegram_switch_step2: "Naaske siia ja laadige allolev nupp uuesti, seejärel logige sisse teise kontoga.",
  telegram_open_web: "Ava Telegram Web",
  telegram_reload_widget: "Logisin välja — laadi nupp uuesti",
  lang_autodetected_toast: "Tuvastatud keel: {language}. Saate seda muuta seadetes.",
  admin_view_active: "Aktiivsed",
  admin_view_archived: "Arhiveeritud",
  admin_restore: "Taasta",
  admin_restored: "Taastatud.",
  admin_hard_delete: "Kustuta jäädavalt",
  admin_hard_delete_title: "Kustuta jäädavalt?",
  admin_hard_delete_confirm: "«{name}» eemaldatakse jäädavalt andmebaasist. Seda tegevust ei saa tagasi võtta.",
  admin_hard_deleted: "Jäädavalt kustutatud.",
  admin_no_archived: "Arhiveeritud üksusi pole.",
  language_desc: "Kasutatakse rakenduse liidese ning teie Telegrami + push-teavituste jaoks.",
  language_saved: "Keel uuendatud.",
  language_error: "Keelt ei õnnestunud uuendada. Palun proovige uuesti.",
  admin_field_language: "Keel",
  edit: "Muuda",
  generic_error: "Midagi läks valesti. Palun proovige uuesti.",
  caregiver_added: "Hooldaja lisatud.",
  caregiver_removed: "Hooldaja eemaldatud.",
  family_added: "Pereliige lisatud.",
  family_removed: "Pereliige eemaldatud.",
  menu: "Menüü",
  dl_companion_app: "Kaaslasrakendus",
  dl_hero_title: "E2 Care Androidile",
  dl_hero_sub: "Paigaldage kaaslasrakendus Moko-toega telefoni, et edastada häireid, seadistada seadmeid ja püsida ühenduses oma hooldusmeeskonnaga — isegi kui töölaud on suletud.",
  dl_android_apk: "Androidi APK",
  dl_version_loading: "versiooni laadimine…",
  dl_released: "Avaldatud {date}",
  dl_download_apk: "Laadi APK alla",
  dl_unavailable: "Pole saadaval",
  dl_preparing: "Ettevalmistamine…",
  dl_manifest_error: "Manifesti ei õnnestunud laadida. Proovige värskendada — kui probleem püsib, võib ehitusserver olla ümberpaigutamisel.",
  dl_whats_new: "Mis on uut",
  dl_installing_title: "Paigaldamine telefoni",
  dl_step1: "Puudutage ülal „Laadi APK alla“. Teie brauser võib hoiatada, et APK-failid võivad seadet kahjustada — see hoiatus on tavaline iga väljaspool Play Store’i alla laaditud installeri puhul.",
  dl_step2: "Avage allalaaditud fail. Android palub esimesel korral lubada installimist sellest brauserist — lülitage luba sisse ja tulge tagasi.",
  dl_step3: "Puudutage „Installi“ ja seejärel lõpetamisel „Ava“.",
  dl_step4: "Logige sisse oma E2 Care mandaatidega.",
  dl_iphone_note: "iPhone’i versioon tuleb hiljem. Praegu kasutage veebitöölauda.",
  dl_back_to_dashboard: "Tagasi töölauale",
  dl_android_min: "Android {version}+",
  admin_device_org_change_hint: "Organisatsiooni muutmine tühjendab praeguse toa ja patsiendi määrangu.",
  admin_view_full: "Täisnimekiri",
  device_filter_assignment: "Määrang",
  device_filter_patient: "Määratud patsiendile",
  device_filter_room: "Määratud toale",
  device_filter_unassigned: "Määramata",
  admin_all_orgs: "Kõik organisatsioonid",
  pagination_prev: "Eelmine",
  pagination_next: "Järgmine",
  pagination_per_page: "Lehe kohta",
  pagination_page_of: "Lehekülg {page} / {pages}",
  pagination_total: "Kokku {total}",
  event_charging: "Laadimine algas",
  event_sos_cancel: "SOS tühistatud",
  event_call: "SOS-kõne",
  device_personal_alarm: "Isiklik häire",
  device_charging: "Laeb",
  device_location: "Asukoht",
  device_current_location: "Praegune asukoht",
  device_no_location: "Asukohta pole veel edastatud.",
  device_location_source: "Allikas",
  device_location_updated: "Uuendatud",
  device_track_1h: "1 t",
  device_track_24h: "24 t",
  device_track_7d: "7 p",
  device_track_last: "Viimane asukoht",
  device_located: "Leitud",
  map_sos: "SOS-häire",
  map_fall: "Kukkumine tuvastatud",
  map_current: "Praegune asukoht",
  alert_timeline: "Häire ajajoon",
  alert_trigger: "Käivitaja",
  alert_calls: "Kõned",
  alert_view_timeline: "Vaata ajajoont",
  alert_no_deliveries: "Teavitusi pole veel saadetud.",
  alert_cancelled_on_device: "SOS tühistati seadmes — häire jääb avatuks, kuni hooldaja selle lahendab.",
  call_answered: "Vastatud",
  call_missed: "Vastamata",
  reopen: "Ava uuesti",
  reopened: "Häire avati uuesti",
  live: "Reaalajas",
  nav_home: "Avaleht",
  family_home_kicker: "Pere vaade",
  family_home_title: "Teie lähedased",
  family_greeting: "Tere",
  family_home_sub: "Rahulik ülevaade sellest, kuidas kõigil läheb.",
  family_status_ok: "on korras",
  family_status_attention: "vajab tähelepanu",
  family_all_calm: "Praegu on kõik rahulik.",
  family_attention_sub: "Vaatame, kuidas tal läheb — üksikasjad allpool.",
  family_last_seen: "viimati nähtud",
  family_latest_alert: "Viimane häire",
  family_no_alerts: "Hiljutisi häireid pole — kõik on hästi.",
  family_view_details: "Vaata üksikasju",
  family_no_device: "Isiklikku häiret pole veel seotud.",
  status_never_reported: "Pole kunagi teatanud",
  mv_title: "Liikumine",
  mv_sub: "{n} liikumisandurilt · 5-minutilised aknad",
  mvo_title: "Liikumine ühe pilguga",
  mvs_moving: "{name} on üleval ja liigub",
  mvs_moving_sub: "Liikus {when}",
  mvs_rest: "{name} puhkab",
  mvs_rest_sub: "Viimati liikus {when}",
  mvs_rest_sub_none: "Viimase 30 päeva jooksul liikumist pole",
  mvs_quiet: "{name} on olnud vaikne tavalisest kauem",
  mvs_quiet_sub: "Liikumist pole olnud {dur}. Lühike kõne võib olla hea mõte.",
  mvs_short_quiet: "Kaua vaikne",
  mvs_room_moving: "Keegi liigub ruumis {name}",
  mvs_room_rest: "{name} on rahulik",
  mvs_room_quiet: "Ruumis {name} pole tavalisest kauem liikumist olnud",
  mvs_sensor: "Liikumisandur ei saada andmeid",
  mvs_sensor_sub: "See puudutab andurit, mitte inimest {name}. Viimane signaal {when}.",
  mvs_nodata: "Liikumisandmeid veel pole",
  mvs_nodata_sub: "Liikumisandur pole veel midagi saatnud.",
  mvd_title: "Viimased 24 tundi",
  mvd_moving: "Liigub",
  mvd_resting: "Puhkab",
  mvd_nosignal: "Signaal puudub",
  mvd_night: "Öö",
  mvd_now: "Praegu",
  mvn_title: "Viimased 7 ööd",
  mvn_last_night: "Eile öösel",
  mvn_last_short: "Eile",
  mvn_calm: "Rahulik",
  mvn_restless: "Rahutu",
  mvn_still: "Väga vaikne",
  mvn_silent: "Andur vaikne",
  mvn_nodata: "Andmed puuduvad",
  mvn_s_calm_none: "Rahulik öö, liikumist polnud {from}–{to}.",
  mvn_s_calm_once: "Rahulik öö, tõusis korra umbes kell {at}.",
  mvn_s_calm_many: "Rahulik öö, tõusis {n} korda, esimest korda umbes {first}, viimati umbes {last}.",
  mvn_s_restless: "Rahutu öö, tõusis {n} korda vahemikus {first}–{last}.",
  mvn_s_still: "Väga vaikne öö, tavalisest vähem liikumist. Pikim puhkus {dur}.",
  mvn_s_still_moved: "Väga vaikne öö, liikus ainult umbes kell {at}. Pikim puhkus {dur}.",
  mvn_s_silent: "Andur oli peaaegu vaikne, seega ei tea me, kuidas öö möödus.",
  mvn_s_nodata: "Selle öö kohta liikumisandmed puuduvad.",
  mv_state_moving: "Liigub",
  mv_state_still: "Puhkab",
  mv_state_inactive: "Passiivne",
  mv_state_silent: "Andur ei saada andmeid",
  mv_state_never: "Pole kunagi teatanud",
  mv_state_nodata: "Andmeid veel pole",
  mv_state_no_sensor: "Liikumisandur puudub",
  mv_last_movement: "Viimane liikumine",
  mv_last_sample: "Anduri viimane signaal",
  mv_none_in_retention: "Viimase 30 päeva jooksul pole",
  mv_silent_hint: "Üle {min} min ühtegi näitu — kontrollige andurit või selle lüüsi. See on seadme rike, mitte liikumatus.",
  mv_inactive_hint: "Üle {min} min liikumist pole, kuigi andur saadab endiselt andmeid.",
  mv_history: "Liikumise ajalugu",
  mv_history_empty: "Selles vahemikus pole veel liikumisandmeid.",
  mv_not_reporting: "Ei saada andmeid",
  mv_no_movement: "Liikumist pole",
  mv_detections: "liikumise tuvastust",
  mv_legend_motion: "Liikumise tuvastused",
  mv_legend_gap: "Ei saada andmeid",
  mv_retention_note: "Ajalugu säilitatakse 30 päeva",
  mv_strip_title: "Liikumine reaalajas",
  mv_strip_sub: "{n} liikumisandur(it)",
  mv_unassigned: "Määramata andur",
  admin_alerts_timezone: "Organisatsiooni ajavöönd",
  admin_alerts_timezone_invalid: "Valige kehtiv IANA ajavöönd.",
  admin_alerts_night_wrap_hint: "Öötunnid kestavad {start} kuni järgmise hommiku {end} ({tz}), st pärast {start} või enne {end}.",
  admin_alerts_night_same_day_hint: "Öötunnid kestavad {start} kuni {end} samal päeval ({tz}).",
  admin_alerts_night_equal: "Algus ja lõpp ei saa olla sama kellaaeg.",
  admin_alerts_inactivity_label: "Passiivsuse lävi",
  admin_alerts_inactivity_question: "Kas see inimene on liikunud? Minutid ilma liikumiseta, enne kui see muutub häire põhjuseks.",
  admin_alerts_silence_label: "Seadme vaikuse lävi",
  admin_alerts_silence_question: "Kas see andur veel suhtleb? Minutid ilma ühegi näiduta, enne kui seda loetakse seadme rikkeks, mitte passiivseks elanikuks.",
  admin_alerts_minutes: "minutit",
  admin_alerts_threshold_invalid: "Sisestage täisarv, mis on suurem kui 0.",
  admin_alerts_thresholds_provisional: "Algväärtusi (180 / 30 min) pole veel häälestatud — kohandage neid oma elanikele.",
  admin_tab_gateways: "Lüüsid",
  gw_title: "Lüüsid",
  gw_status_deactivated: "Deaktiveeritud",
  gw_scope_pending: "Teie organisatsiooni lüüsid ilmuvad siia, kui taustasüsteemi uuendus on töös.",
  gw_none_for_org: "Sellele organisatsioonile pole veel lüüsi määratud.",
  gw_col_room: "Ruum",
  gw_unassigned: "Määramata",
  gw_never: "Mitte kunagi",
  gw_edit_title: "Muuda lüüsi",
  gw_new_title: "Uus lüüs",
  gw_super_field: "Seda saab muuta ainult superadmin",
  gw_mac_invalid: "Sisestage 12 kuueteistkümnendmärki, nt AA:BB:CC:DD:EE:FF",
  gw_hw_type: "Riistvara tüüp",
  gw_notes: "Märkmed",
  gw_manage_sub: "Andurite andmeid edastavad BLE-jaoturid: olek, organisatsioon ja ruum. Vaikne lüüs teeb vaikseks kõik selle taga olevad andurid.",
  gw_filter_all: "Kõik organisatsioonid",
  gw_new: "Uus lüüs",
  gw_col_assignment: "Organisatsioon · Ruum",
  gw_backend_pending: "Selleks on vaja taustasüsteemi uuendust, mis pole veel paigaldatud.",
  gw_save_failed: "Salvesta lüüs",
  gw_created: "Lüüs loodud",
  gw_saved: "Lüüs salvestatud",
  gw_reactivated: "Lüüs taasaktiveeritud",
  gw_deactivated: "Lüüs deaktiveeritud",
  gw_reactivate: "Taasaktiveeri",
  gw_deactivate: "Deaktiveeri",
  gw_reactivate_title: "Taasaktiveerida {name}?",
  gw_deactivate_title: "Deaktiveerida {name}?",
  gw_reactivate_desc: "See arvestatakse jälle oleku ja hoiatuste hulka.",
  gw_deactivate_desc: "See ei lähe enam oleku ja hoiatuste hulka. Ajalugu säilib ja saate selle igal ajal taasaktiveerida.",
  gw_heard_title: "Kuuldavad seadmed",
  gw_heard_sub: "Andurid, mida see lüüs viimase 24 tunni jooksul edastas.",
  gw_heard_none: "Viimase 24 tunni jooksul ühtegi seadet.",
  gw_heard_unknown: "Tundmatud seadmed",
  gw_msgs_short: "sõn",
  gw_avg: "kesk.",
  gw_samples_short: "proovi",
  gw_not_found: "Lüüsi ei leitud või see pole teile nähtav.",
  gw_one: "Lüüs",
  gw_manage_link: "Halda administreerimises",
  gw_rssi_range: "Signaali vahemik",
  gw_longest_gap: "Pikim katkestus",
  gw_config_push: "Viimane seadistuse saatmine",
  gw_sub: "BLE-jaoturid, mis edastavad anduriandmeid. Ainult lugemiseks — vaikne lüüs muudab vaikseks kõik selle taga olevad andurid.",
  gw_super_only: "Lüüside olek on saadaval ainult superadministraatoritele.",
  gw_load_failed: "Lüüside laadimine",
  gw_status_reporting: "Teatab",
  gw_status_silent: "Vaikne",
  gw_status_never_seen: "Pole kunagi nähtud",
  gw_returned: "Tagasi pärast {h} h pausi (lõppes {at})",
  gw_count_reporting: "{n} teatab",
  gw_count_silent: "{n} vaikset",
  gw_count_never: "{n} pole kunagi nähtud",
  gw_count_deactivated: "{n} deaktiveeritud",
  gw_window: "Aegunud pärast {h} h ilma sõnumita",
  gw_col_name: "Lüüs",
  gw_col_status: "Olek",
  gw_col_msgs: "Sõnumid 24 h",
  gw_col_discard: "Kõrvale heidetud",
  gw_last_message: "Viimane sõnum",
  gw_devices_seen: "Nähtud seadmed",
  gw_hours_active: "Aktiivsed tunnid",
  gw_unregistered_title: "Teatab ilma registrikandeta",
  gw_unregistered_desc: "Need tunnused esinevad lüüside tegevuses, kuid neil pole kirjet (nt IMEI-ga teatav seade). Kahe allika kogusummad võivad õigustatult erineda.",
  nav_reports: "Aruanded",
  rep_night_title: "Öö kokkuvõte",
  rep_night_desc: "Hommikune kokkuvõte iga elaniku liikumisest organisatsiooni öötundidel ja anduri vaikuseperioodidest.",
  rep_last_night: "Eelmine öö",
  rep_nights_ago: "{n} ööd tagasi",
  rep_policy_fallback: "vaikimisi öötunnid (poliitika pole saadaval)",
  rep_movement: "Liikumine",
  rep_windows: "{n} aktiivset 5 min akent",
  rep_no_movement: "Liikumist pole",
  rep_first_movement: "Esimene liikumine",
  rep_longest_still: "Pikim liikumatu periood",
  rep_silences: "Anduri vaikus",
  rep_none: "Puudub",
  rep_coverage: "{pct}% saadud",
  rep_night_note: "Kellaajad on organisatsiooni ajavööndis. Liikumatust arvestatakse ainult siis, kui andur saadab andmeid; vaikuseläve ületavad vaikused on loetletud eraldi.",
  dh_reporting_title: "Teatamise seisund",
  dh_never_reported_desc: "Registreeritud, kuid pole kunagi teatanud. See on lõpetamata paigaldus, mitte võrguühenduseta seade.",
  dh_interval_still: "Mõõdetud intervall (paigal)",
  dh_interval_moving: "Mõõdetud intervall (liikumisel)",
  dh_interval_samples: "Mõõtmisproovid",
  dh_interval_unmeasured: "Mõõdetud intervalli veel pole — kehtib organisatsiooni vaikuse lävi.",
  dh_interval_note: "Intervallid mõõdetakse saadud sõnumite põhjal, mitte seadistatud väärtuse järgi.",
  rep_dur_h_min: "{h} h {m} min",
  rep_dur_min: "{m} min",
  rep_shared_room: "Jagatud tuba — võib sisaldada teiste liikumist",
  rep_no_data_night: "Selle öö kohta andmeid pole — andur ei saatnud andmeid (või polnud veel paigaldatud).",
  nav_buildings: "Hooned",
  imei_label: "IMEI",
  imei_hint: "15 numbrit, trükitud seadme tagaküljele",
  imei_length: "IMEI-s on 15 numbrit",
  imei_invalid: "See IMEI ei kehti. Kontrollige numbreid",
  imei_resident_note: "Häirenupp järgib elanikku, seega seda ei määrata toale.",
  imei_online_hint: "Seade ilmub võrku pärast esimest elumärki, umbes 5 minutit pärast sisselülitamist.",
  forgot_link: "Unustasite parooli? Klõpsake siin",
  forgot_title: "Lähtesta parool",
  forgot_sub: "Sisestage oma e-post ja saadame lingi parooli lähtestamiseks.",
  forgot_submit: "Saada link",
  forgot_sent: "Kui selle e-postiga konto on olemas, saatsime lingi parooli lähtestamiseks. Kontrollige postkasti.",
  forgot_back: "← Tagasi sisselogimisse",
  reset_title: "Määra uus parool",
  reset_sub: "Valige oma kontole uus parool.",
  reset_new_password: "Uus parool",
  reset_confirm_password: "Kinnita parool",
  reset_hint: "Vähemalt 8 märki.",
  reset_submit: "Uuenda parooli",
  reset_success: "Parool uuendatud. Suuname sisselogimisse…",
  reset_too_short: "Parool peab olema vähemalt 8 märki.",
  reset_mismatch: "Paroolid ei kattu.",
  reset_no_token: "See link on vigane või puudub. Taotlege sisselogimislehelt uus.",
  reset_failed: "See link on vigane või aegunud. Taotlege uus.",
  admin_tab_device_types: "Seadmetüübid",
  admin_dt_title: "Seadmetüübid",
  admin_dt_sub: "Seadmemudelite kataloog. Nimetage tüübi kuvatav nimi ümber — sisemine võti, IoT-vastendus ja sünkroonimine ei muutu.",
  admin_dt_col_label: "Kuvatav nimi",
  admin_dt_col_key: "Sisemine võti",
  admin_dt_col_category: "Kategooria",
  admin_dt_col_wearable: "Kantav",
  admin_dt_col_ble_sync: "BLE sünkroonimine",
  admin_dt_col_ble_type_id: "BLE tüübi ID",
  admin_dt_wearable_yes: "Elaniku kanda",
  admin_dt_wearable_no: "Paigaldatud",
  admin_dt_ble_sync_on: "Nõutud",
  admin_dt_ble_sync_off: "Väljas",
  admin_dt_edit_label: "Muuda nime",
  admin_dt_edit_title: "Nimeta kuvatav nimi ümber",
  admin_dt_edit_desc: "Muutub ainult inimloetav nimi. Seadmed, filtrid ja integratsioonid kasutavad edasi sisemist võtit „{key}”.",
  admin_dt_label_saved: "Nimi uuendatud.",
  admin_dt_label_required: "Nimi ei tohi olla tühi.",
  admin_dt_load_failed: "Seadmetüüpide laadimine",
  admin_dt_save_failed: "Nime uuendamine",
  admin_dt_readonly_hint: "Ainult superadministraatorid saavad nimesid muuta.",
  sensor_climate: "Kliima",
  sensor_temperature: "Temperatuur",
  sensor_humidity: "Niiskus",
  sensor_last_reading: "Viimane näit",
  sensor_history_title: "Temperatuur ja niiskus (48 h)",
  sensor_history_empty_title: "Näite veel pole",
  sensor_history_empty_sub: "Määrake sellele toale H4 Pro andur, et näha kliimaajalugu.",
  admin_thresholds_title: "Andurite läved",
  admin_thresholds_desc: "Temperatuuri ja niiskuse häirepiirid selle organisatsiooni H4 Pro anduritele.",
  admin_thresholds_temp_min: "Min temperatuur",
  admin_thresholds_temp_max: "Max temperatuur",
  admin_thresholds_hum_min: "Min niiskus",
  admin_thresholds_hum_max: "Max niiskus",
  admin_thresholds_temp_invalid: "Min temperatuur peab olema madalam kui max temperatuur.",
  admin_thresholds_hum_invalid: "Min niiskus peab olema madalam kui max niiskus.",
  admin_thresholds_hint: "Kõik neli on valikulised — jätke väli tühjaks, kui sellel piiril häiret pole vaja.",
  admin_thresholds_cooldown: "Häirete paus",
  admin_thresholds_cooldown_placeholder: "Vaikimisi: 30 min",
  admin_thresholds_cooldown_help: "Minutid korduvate anduri häirete vahel. Jätke tühjaks süsteemi vaikeväärtuse (30 min) jaoks.",
  admin_thresholds_cooldown_invalid: "Paus peab olema täisarv, vähemalt 1 minut.",
  admin_thresholds_saved: "Läved salvestatud.",
  admin_thresholds_load_failed: "Lävede laadimine",
  admin_thresholds_save_failed: "Lävede salvestamine",
  room_activity_view_all: "Vaata kõiki sündmusi",
  role_super_admin: "Superadministraator",
  assign_device: "Määra seade",
  select_device: "Valige seade…",
  admin_patient_no_devices_assigned: "Seadmeid pole määratud.",
  admin_patient_no_wearables: "Selles organisatsioonis pole kantavaid seadmeid saadaval.",
  admin_patient_device_reassign: "määra ümber",
  recent_critical_alerts_title: "Hiljutised kriitilised häired",
  rooms_building_clear: "Tühjenda filter",
  buildings_title: "Hooned",
  buildings_sub: "Iga hoone, mida jälgite, koos tubade, elanike ja seadmetega.",
  buildings_view_rooms: "Vaata tube",
  wt_title: "Nädala trend",
  wt_desc: "Seitse ööd kõrvuti iga elaniku — või jagatud toa — kohta, et märgata rahutuid või ebatavaliselt liikumatuid öid.",
  wt_baseline_note: "iga ööd võrreldakse rea 7 öö mediaaniga",
  wt_no_sensors: "Ühelgi elanikul pole veel liikumisandurit.",
  wt_flag_restless: "Rahutu",
  wt_flag_still: "Ebatavaliselt liikumatu",
  wt_flag_nodata: "Andmeid pole",
  wt_flag_silent: "Andur peaaegu vaikne",
  rep_sensor_silent: "Andur saatis andmeid vaid {pct}% sellest ööst. Lüngad tähendavad, et andur lakkas andmeid saatmast, mitte et elanik oli liikumatu.",
  wt_legend_active: "Aktiivsed 5 min aknad",
  wt_legend_still: "Pikim liikumatus (h)",
  fap_title: "Pereliikmed saavad hoiatusi käsitleda",
  fap_desc: "Kui sees, saavad pereliikmed {org} oma elanike hoiatusi kinnitada, lahendada, uuesti avada ja märkmetega täiendada.",
  note_saved: "Märkus salvestatud",
  event_device_silent: "Andur vaikib",
  event_no_movement: "Liikumist pole",
  event_no_rise: "Liikumist pole pärast ööd",

  dur_lt_min: "vähem kui minut",
  dur_min: "{m} min",
  dur_h: "{h} h",
  dur_h_min: "{h} h {m} min",
  am_fall: "Tuvastati kukkumine",
  am_sos: "SOS-nuppu vajutati",
  am_low_battery: "Seadme aku on tühjenemas",
  am_low_battery_dev: "Aku tühjenemas: {device}",
  am_door: "Uks lahti",
  am_door_in: "Uks lahti: {place}",
  am_door_in_detail: "Uks lahti: {place} ({detail})",
  am_window: "Aken lahti",
  am_window_in: "Aken lahti: {place}",
  am_window_in_detail: "Aken lahti: {place} ({detail})",
  am_silent: "Liikumisandur ruumis {place} ei ole andmeid saatnud umbes {dur} — kontrollige toidet või lüüsi",
  am_silent_nodur: "Liikumisandur ruumis {place} lõpetas andmete saatmise — kontrollige toidet või lüüsi",
  am_nomove: "Ruumis {place} pole liikumist tuvastatud umbes {dur}",
  am_nomove_nodur: "Ruumis {place} pole liikumist tuvastatud",
  am_norise: "Ruumis {place} pole liikumist tuvastatud pärast öö lõppu (tavaliselt üleval kella {time}ks)",
  am_norise_notime: "Ruumis {place} pole liikumist tuvastatud pärast öö lõppu",
  amf_silent_res: "{name} liikumisandur ei ole andmeid saatnud alates {time}, seega liikumist hetkel ei jälgita.",
  amf_silent_room: "Liikumisandur ruumis {place} ei ole andmeid saatnud alates {time}, seega liikumist seal hetkel ei jälgita.",
  amf_sensor_ok: "Andur töötab; see lihtsalt pole kedagi liikumas näinud.",
  amf_team: "Hooldusmeeskonda on nende töölaual teavitatud.",
  amf_contact_device: "Olete selle seadme kontaktisik.",
  amf_contact_resident: "Olete kontaktisik: {name}.",
  al_tab_care: "Hooldus",
  al_tab_maint: "Tehniline hooldus",
  al_maint_hint: "Vaikinud andurid ja tühjenevad akud: tehniline töö, mitte hooldussündmused.",
  al_maint_empty: "Andurite ega akudega probleeme pole.",
  al_auto_closed: "Suleti automaatselt",
  al_auto_closed_reason: "Suleti automaatselt — {reason}",
  al_never_seen: "keegi ei näinud seda enne sulgemist",
  al_resolved_by: "Lahendas {name}",
  al_reason_movement: "liikumine jätkus",
  al_reason_sensor: "andur saadab taas andmeid",
  al_admin_only_ack: "Seda hoiatust saab käsitleda ainult administraator, sest see ei ole seotud ühe elanikuga.",
  why_title: "Miks see käivitus?",
  why_since_motion: "Viimasest liikumisest",
  why_since_sample: "Anduri viimastest andmetest",
  why_threshold: "Lävi",
  why_up_by: "Tavaliselt üleval kell",
  why_night: "Ööaken",
  why_source: "Läve määras",
  why_src_org: "see organisatsioon",
  why_src_default: "vaikeväärtused",
  why_state: "Anduri olek",
  why_checked: "Kontrollitud",
  why_approx: "Kontrollid toimuvad iga 5 minuti järel, seega hoiatuste ajad on ligikaudsed.",
  mon_label: "Liikumise jälgimine",
  mon_active: "aktiivne",
  mon_down: "ei saada andmeid",
  mon_down_since: "ei saada andmeid alates {time}",
  admin_alerts_up_by_label: "Tavaliselt üleval kell",
  admin_alerts_up_by_question: "Kui öö lõpu ja selle kellaaja vahel liikumist ei nähta, luuakse hoiatus „pole liikumist pärast öö lõppu”.",
  admin_alerts_up_by_invalid: "Peab olema hiljem kui öö lõpp ({end}): see on kellaaeg, mil elanikud on tavaliselt üleval, pärast ööd.",
  admin_alerts_up_by_format: "Sisestage aeg kujul HH:MM.",
  admin_alerts_escalation_label: "Teavita peret vaikinud andurist pärast",
  admin_alerts_escalation_question: "Personal näeb vaikinud andurit kohe. Peret teavitatakse ainult siis, kui see on pärast seda aega endiselt lahendamata (kohe, kui organisatsioonil pole hooldajaid).",
  admin_alerts_cooldown_note: "Pärast hoiatuse sulgemist võib sama hoiatus tagasi tulla, kui lävi taas ületatakse. Hommikune hoiatus käivitub kõige rohkem kord päevas.",
  admin_alerts_stored_invalid: "Salvestatud aeg ({up}) ei ole pärast öö lõppu ({end}), seega hommikused hoiatused ei saa töötada ja seda poliitikat ei saa salvestada enne parandamist.",
  admin_alerts_defaults_badge: "Vaikeväärtused",

  fap_auto_on: "Automaatne: sees, sest sellel organisatsioonil pole hooldajaid.",
  fap_auto_off: "Automaatne: väljas, sest sellel organisatsioonil on hooldajad.",
  fap_manual: "Määranud administraator.",
  fap_reset: "Tagasi automaatseks",
  fap_saved: "Salvestatud",
  fap_save_failed: "Salvestamine ebaõnnestus. Proovige uuesti.",
  fap_pending: "Varsti",
  fap_retry: "Proovi uuesti",
  recap_title: "Hommikune öö kokkuvõte",
  recap_desc_staff: "Iga päev kell 07:00 (organisatsiooni aja järgi) eelmise öö kokkuvõte kõigi teie organisatsiooni elanike kohta.",
  recap_desc_family: "Iga päev kell 07:00 (organisatsiooni aja järgi) eelmise öö kokkuvõte teie lähedaste kohta.",
  recap_on: "Sees",
  recap_off: "Väljas",
  recap_email: "E-post",
  recap_telegram_link_first: "Ühendage ülal Telegram, et seda sealt saada.",
  recap_no_channel: "Valige vähemalt üks kanal, muidu midagi ei saadeta.",
  recap_last_sent: "Viimati saadetud {at}",
  recap_saved: "Eelistused salvestatud.",
  recap_save_failed: "Eelistusi ei õnnestunud salvestada.",
  recap_unavailable: "Varsti",
  topbar_org_label: "Organisatsioon",
  device_ota_phase2: "OTA juurutamine muutub interaktiivseks 2. etapis.",
  event_window_open: "Aken avatud",
  event_window_close: "Aken suletud",
  event_alarm_end: "Häire lõppes",
  wt_h: "h",
  wt_load_failed: "Liikumisajalugu ei õnnestunud laadida. Proovige hiljem.",
  recap_load_failed: "Eelistusi ei õnnestunud laadida — puudutage uuesti proovimiseks.",
  mv_shared_note: "See elanik jagab tuba. Toaandur ei erista elanikke, seega kuvatakse liikumist toa, mitte ühe inimese kohta.",
  mv_shared_link: "Vaata liikumist: {room}",
  mv_room_shared_note: "Jagatud {n} elaniku vahel — seda liikumist ei saa omistada ühelegi neist.",
  rep_shared_room_row: "Jagatud tuba · {names}",
  admin_motion_resident: "Elaniku voodiandur",
  admin_motion_resident_hint: "Valikuline. Valige elanik ainult siis, kui andur jälgib tema isiklikku ala (nt suunatud voodile). Siis kasutavad tema liikumisgraafikud seda ka jagatud toas.",
  admin_motion_whole_room: "Kogu tuba",
};
export default et;
